import PageLayout from "../../layout/page"
import { arrowLeft } from "../../../constant/icons"
import { Button } from "reactstrap";
import { WizardBox as WizardBoxDefault } from "./wizardBox/layout";
import { WizardBox as WizardBoxRdo } from "./wizardBoxRdo/layout";

const AddUpdateJob = (props: any) => {
  const { closeAddUpdate, api, selectedFunction, app } = props

  return (
    <PageLayout
      title={<><Button color="link" className="btn-back" onClick={closeAddUpdate}>{arrowLeft.icon} </Button>Function</>}
      View={app === "rdo" ? (
        <WizardBoxRdo
          api={api}
          selectedFunction={selectedFunction}
          closeAddUpdate={closeAddUpdate}
        />
      ) : (
        <WizardBoxDefault
          api={api}
          selectedFunction={selectedFunction}
          closeAddUpdate={closeAddUpdate}
        />
      )}
    />
  );
}
export { AddUpdateJob }